var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasRows) ? _c('div', {
    staticClass: "data-grid"
  }, [_c('table', {
    staticClass: "uk-table uk-table-divider uk-table-justify",
    class: _vm.tableClass
  }, [_c('thead', {
    staticClass: "data-grid__header"
  }, [_c('tr', {
    staticClass: "data-grid__header-row"
  }, [(_vm.selectable) ? _c('th', {
    staticClass: "data-grid__header-cell--selector uk-table-shrink"
  }, [(_vm.multiple) ? _c('input', {
    ref: "toggleAllCheckbox",
    staticClass: "uk-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allRowsSelected,
      "indeterminate": _vm.someRowsSelected
    },
    on: {
      "click": _vm.toggleAllSelected
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("beforeHead"), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return (_vm.isSortableField(field)) ? _c('th', {
      staticClass: "data-grid__header-cell data-grid__header-cell--sortable",
      on: {
        "click": function($event) {
          _vm.sortBy(field)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.columns[field]) + "\n          "), (_vm.sortField == field) ? _c('span', {
      staticClass: "data-grid__sort-indicator"
    }, [(_vm.sortDirection == 'desc') ? _c('icon', {
      attrs: {
        "name": "chevron-down"
      }
    }) : _c('icon', {
      attrs: {
        "name": "chevron-up"
      }
    })], 1) : _vm._e()]) : _c('th', {
      staticClass: "data-grid__header-cell"
    }, [_vm._v("\n          " + _vm._s(_vm.columns[field]) + "\n        ")])
  }), _vm._v(" "), (_vm.showActions) ? _c('th') : _vm._e()], 2)]), _vm._v(" "), (_vm.hasRows) ? _c('tbody', {
    staticClass: "data-grid__body",
    class: {
      'data-grid__body--loading': _vm.isLoading
    }
  }, _vm._l((_vm.rows), function(row) {
    return _c('tr', {
      staticClass: "data-grid__row"
    }, [_vm._t("row", [(_vm.selectable) ? _c('td', {
      staticClass: "data-grid__cell--selector uk-table-shrink"
    }, [(_vm.multiple) ? _c('input', {
      staticClass: "uk-checkbox",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isSelectedRow(row)
      },
      on: {
        "click": function($event) {
          _vm.toggleSelected(row)
        }
      }
    }) : _c('input', {
      staticClass: "uk-radio",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "checked": _vm.isSelectedRow(row)
      },
      on: {
        "click": function($event) {
          _vm.selectExclusively(row)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._t("beforeRow", null, {
      row: row
    }), _vm._v(" "), _vm._l((_vm.fields), function(field) {
      return _c('td', {
        staticClass: "data-grid__cell"
      }, [_vm._t(field, [_vm._v("\n              " + _vm._s(row[field]) + "\n            ")], {
        row: row,
        value: row[field]
      })], 2)
    }), _vm._v(" "), (_vm.showActions) ? _c('td', {
      staticClass: "data-grid__cell"
    }, [_vm._t("actions", [_c('data-grid-actions', {
      staticClass: "data-grid__actions",
      attrs: {
        "editable": _vm.editable,
        "removable": _vm.removable
      },
      on: {
        "edit": function($event) {
          _vm.$emit('edit', row)
        },
        "remove": function($event) {
          _vm.$emit('remove', row)
        }
      }
    })], {
      row: row
    })], 2) : _vm._e()], {
      fields: _vm.fields,
      row: row
    })], 2)
  })) : _vm._e()]), _vm._v(" "), (_vm.pageInfo) ? _c('paginator', {
    staticClass: "data-grid__paginator",
    attrs: {
      "change-route": _vm.changeRoute,
      "page-info": _vm.pageInfo
    },
    on: {
      "change-page": _vm.changePage
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "data-grid data-grid--empty uk-placeholder uk-text-center"
  }, [_c('icon', {
    staticClass: "uk-margin-small-right",
    attrs: {
      "name": "bolt"
    }
  }), _vm._v(" "), _vm._t("empty", [_vm._v(_vm._s(_vm.$t('hints.empty')))])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697b3a0b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/DataGrid.vue
// module id = 2031
// module chunks = 0